module.exports = __webpack_public_path__ + "static/apple-icon-120x120-8b109fd6ae8e0b79e9dfde1e7b4712a1.png";